<template lang="pug">
	.v-image-slider.image-slider(:class="['image-slider--' + mode, {'loading': loading, 'image-slider--full': slider && slider.items && slider.items.length > 1}]")
		.image-slider__slider(v-if="slider && slider.items && slider.items.length")
			button.hero-slider__gallery-btn(type="button" @click="openGallery" v-if="mode === 'regular'" aria-label="Открыть во весь экран")
			.image-slider__arrow.image-slider__arrow--prev(ref="prev")
				v-svg-icon.image-slider__arrow-icon(icon="slide-left")
			.image-slider__arrow.image-slider__arrow--next(ref="next")
				v-svg-icon.image-slider__arrow-icon(icon="slide-right")
			v-swiper-slider(v-if="slider && slider.items && slider.items.length"
				:options="options"
				:navigation="navigation"
				@slide-change="onSlideChange"
				@swiper="onSwiper")
				template(v-for="(slide, index) in slider.items" :key="index")
					v-swiper-slide
						.image-slider__item
							template(v-if="slide.type === 'video' || slide.type === 'youtube'")
								.image-slider__iframe-wrap
									v-video.image-slider__video(:type="slide.type" :src="slide.link" :poster="slide.src")
							template(v-else)
								v-image.image-slider__image(:src="slide.src" :sources="computedSourcesBig(slide)")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId';
import {SwiperSlide} from 'swiper/vue';
import breakpoints from '../scripts/breakpoints';
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		mode: {
			type: String,
			default: 'regular'
		},

		title: {
			type: String,
			default: null
		},

		initialIndex: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			newOptions: null,
			isMdTimeout: null,
			realIndex: 0,
			options: {
				slidesPerView: 1,
				spaceBetween: 10,
				loop: false,
				initialSlide: this.initialIndex,
				breakpoints: {
					// when window width is >= x
					[breakpoints['xl-min']]: {
						spaceBetween: 0
					},
					[breakpoints['lg-min']]: {
						spaceBetween: 0
					},
					[breakpoints['sm-min']]: {
						spaceBetween: 0
					}
				}
			},
			navigation: false
		};
	},

	methods: {
		onSwiper(e) {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		onSlideChange(e) {
			this.realIndex = e.realIndex;
		},

		openGallery() {
			let dataGallery = {
				items: this.slider.items
			};
			controller.openModal({
				className: 'modal--gallery',
				content: `<v-gallery :data-source='${(dataGallery ? JSON.stringify(dataGallery) : null)}' :initial-index='${this.realIndex}'></v-gallery>`
			});
		},

		computedSourcesBig(item) {
			return [
				{
					'src': item.big,
					'size': '1x'
				},
				{
					'src': item.big_2x,
					'size': '2x'
				}
			];
		},

		dataSet(data) {
			this.slider = data;
			this.uniqueId = uniqueId('swiper-');
		}
	}
};
</script>